import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_SANDBOX, RELATED_PRODUCT } from '../../../Constants/Config';

export const fetchRelatedProducts = createAsyncThunk(
  'relatedProducts/fetchRelatedProducts',
  async (merchantId, { rejectWithValue }) => {    
    try {
      const formData = new FormData();
      formData.append('merchant_id', merchantId?.merchant_id);

      const response = await axios.post(`${BASE_URL_SANDBOX}${RELATED_PRODUCT}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.status === 'success') {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch related products');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const relatedProductsSlice = createSlice({
  name: 'relatedProducts',
  initialState: {
    products: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearRelatedProducts: (state) => {
      state.products = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelatedProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRelatedProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchRelatedProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export const { clearRelatedProducts } = relatedProductsSlice.actions;
export default relatedProductsSlice.reducer;
